const platform = require('platform');
const osName = platform.os.family;
const KEYCODE_LEFT = 37;
const KEYCODE_RIGHT = 39;

$('.js-scrollup').on('click', scrollUp);

export function scrollUp() {
	$('html').velocity('scroll', {axis: '0'});
}

$(document).ready(() => {
	if (osName == 'OS X') {
		$('.pagenav:not(.pagenav--bottom) .pagenav-help__key').html('Alt');
	} else if (osName == 'Android' || osName == 'iOS') {
		$('.pagenav-help').remove();
	} else {
		$('.pagenav:not(.pagenav--bottom) .pagenav-help__key').html('Ctrl');
	}
});

$(document).keydown(function (event) {
	if (platform.os.family == 'OS X') {
		if (event.altKey && event.keyCode == KEYCODE_LEFT) {
			toLeft(event);
		} else if (event.altKey && event.keyCode == KEYCODE_RIGHT) {
			toRight(event);
		}
	} else {
		if (event.ctrlKey && event.keyCode == KEYCODE_LEFT) {
			toLeft(event);
		} else if (event.ctrlKey && event.keyCode == KEYCODE_RIGHT) {
			toRight(event);
		}
	}
});

function toLeft(event) {
	var lefllink = $('.pagenav__link--prev').attr('href');
	event.preventDefault(event);
	if (lefllink != undefined) {
		document.location.href = lefllink;
	}
}

function toRight(event) {
	var rightlink = $('.pagenav__link--next').attr('href');
	event.preventDefault(event);
	if (rightlink != undefined) {
		document.location.href = rightlink;
	}
}

$(document).on('touchstart', function () {
	if ($('.pagenav__link').hasClass('is-touch')) {
		$('.pagenav__link').removeClass('is-touch');
	}
});

$('.pagenav__link').on('touchstart', function (e) {
	var $this = $(this);
	if ($this.hasClass('pagenav__link--disabled')) {
		e.preventDefault();
		return false;
	} else {
		if ($this.hasClass('is-touch')) {
			document.location.href = $this.attr('href');
			return false;
		} else {
			$this.addClass('is-touch');
			$('.pagenav__link').not(this).removeClass('is-touch');
			e.preventDefault();
			return false;
		}
	}
});

$('.js-scrollup').on('touchstart', function () {
	var $this = $(this);
	$this.addClass('is-touch');
});


//TODO: Адаптировать все варианты кроме vertical под ф-ю
export function setNavTitle(config) {
	function setTitle(key) {
		if (config.customTooltip) {
			$('.pagenav .pagenav-help__key').html(key);
		} else {
			let prevTitleText = `(${key} + ←)`;
			let nextTitleText = `(${key} + →)`;
			let $prevLink = $('.pagenav .pagenav__link--prev');
			let $nextLink = $('.pagenav .pagenav__link--next');

			if (!config.buttonWithText) {
				$prevLink.attr('title', `${$prevLink.attr('title')} ${prevTitleText}`);
				$nextLink.attr('title', `${$nextLink.attr('title')} ${nextTitleText}`);
			} else {
				$prevLink.attr('title', prevTitleText);
				$nextLink.attr('title', nextTitleText);
			}
		}
	}

	if (osName == 'OS X') {
		setTitle('Alt');
	} else {
		setTitle('Ctrl');
	}
}



// WEBPACK FOOTER //
// ./temp/components/page-nav/index.js